function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  will-change: transform;\n  transition: opacity 300ms ease-in-out;\n  top: 0;\n  left: 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { AnimationTypes, LayerContextType, Layers, OrderedLayers } from '../constants';
import PropTypes from 'prop-types';
import React from 'react';
import renderOnLayer from '../renderOnLayer';
import styled from 'styled-components';
var AnchoredLayerContentContainer = styled.div(_templateObject());
export var AnchoredLayerContent = function AnchoredLayerContent(_ref) {
  var inProp = _ref.in,
      animationOptions = _ref.animationOptions,
      onExited = _ref.onExited,
      innerRef = _ref.innerRef,
      cssPosition = _ref.cssPosition,
      direction = _ref.direction,
      transform = _ref.transform,
      style = _ref.style,
      children = _ref.children,
      hidden = _ref.hidden,
      enter = _ref.enter,
      exit = _ref.exit,
      customAnimation = _ref.customAnimation,
      appear = _ref.appear,
      props = _objectWithoutProperties(_ref, ["in", "animationOptions", "onExited", "innerRef", "cssPosition", "direction", "transform", "style", "children", "hidden", "enter", "exit", "customAnimation", "appear"]);

  var Animation = typeof customAnimation === 'string' ? AnimationTypes.None : customAnimation;
  return React.createElement(AnchoredLayerContentContainer, _extends({
    innerRef: innerRef,
    style: _objectSpread({}, style, {
      position: cssPosition,
      transform: transform,
      // if the element is hidden,
      // make it hidden visibly with
      // opacity, and prevent interaction
      // via pointer-events: none
      opacity: hidden ? 0 : 1,
      pointerEvents: hidden ? 'none' : 'auto'
    })
  }, props), React.createElement(Animation, {
    direction: direction,
    component: "div",
    in: inProp,
    onExited: onExited,
    animationOptions: animationOptions
  }, children));
};
AnchoredLayerContent.propTypes = {
  in: PropTypes.bool,
  animationOptions: PropTypes.object,
  customAnimation: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  onExited: PropTypes.func,
  innerRef: PropTypes.func.isRequired,
  cssPosition: PropTypes.string,
  transform: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
  direction: PropTypes.string,
  hidden: PropTypes.bool
};
AnchoredLayerContent.defaultProps = {
  customAnimation: AnimationTypes.Slide
};

var renderOnLayerWithOptions = function renderOnLayerWithOptions(layer) {
  return renderOnLayer(layer, AnchoredLayerContent, {
    AnimationType: AnimationTypes.Custom
  });
};

var LayerContentOverContent = renderOnLayerWithOptions(Layers.PopoverContent);
LayerContentOverContent.displayName = 'LayerContentOverContent';
var LayerContentOverPopoverContent = renderOnLayerWithOptions(Layers.Sheet);
LayerContentOverPopoverContent.displayName = 'LayerContentOverPopoverContent';
var LayerContentOverSheet = renderOnLayerWithOptions(Layers.Modal);
LayerContentOverSheet.displayName = 'LayerContentOverSheet';
var LayerContentOverModal = renderOnLayerWithOptions(Layers.PopoverModal);
LayerContentOverModal.displayName = 'LayerContentOverModal';

var AnchoredLayerContainer = function AnchoredLayerContainer(_ref2, context) {
  var initialDirection = _ref2.initialDirection,
      customAnimation = _ref2.animation,
      props = _objectWithoutProperties(_ref2, ["initialDirection", "animation"]);

  var orderedLayerIndex = OrderedLayers.indexOf(context.currentLayerContext); // This removes the Node from the TransitionGroup
  // and is needed to ensure the content animates out

  if (props.children) {
    switch (context.currentLayerContext) {
      case Layers.PopoverContent:
        return React.createElement(LayerContentOverPopoverContent, _extends({}, props, {
          customAnimation: customAnimation,
          animationOptions: {
            direction: initialDirection,
            enterDuration: 100
          }
        }));

      case Layers.Sheet:
        return React.createElement(LayerContentOverSheet, _extends({}, props, {
          customAnimation: customAnimation,
          animationOptions: {
            direction: initialDirection,
            enterDuration: 100
          }
        }));

      case Layers.Modal:
        return React.createElement(LayerContentOverModal, _extends({}, props, {
          customAnimation: customAnimation,
          animationOptions: {
            direction: initialDirection,
            enterDuration: 100
          }
        }));

      default:
        if (orderedLayerIndex >= OrderedLayers.length - 1) {
          // Render the children on the top-most Layer if content
          // is on the top-most Layer
          return React.createElement(LayerContentOverModal, _extends({}, props, {
            customAnimation: customAnimation,
            animationOptions: {
              direction: initialDirection,
              enterDuration: 100
            }
          }));
        } // Default to the lowest Layer


        return React.createElement(LayerContentOverContent, _extends({}, props, {
          customAnimation: customAnimation,
          animationOptions: {
            direction: initialDirection,
            enterDuration: 100
          }
        }));
    }
  }

  return null;
};

AnchoredLayerContainer.propTypes = {
  animation: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  children: PropTypes.node,
  initialDirection: PropTypes.string
};
AnchoredLayerContainer.contextTypes = {
  currentLayerContext: LayerContextType
};
export default AnchoredLayerContainer;